import { Card, Col, Row, Table } from "antd";
import React from "react";
import logoImg from "../../images/logo.jpg";
import { ColumnProps } from "antd/es/table";
import "./style.css";

const Home = () => {
  const dataSource = [
    {
      key: "1",
      a1: "某产品一期",
      a2: "7845241800020224",
      a3: "-",
      a4: "-",
      a5: "谢**",
      a6: "229,800",
      a7: "33,200",
      a8: "3,155",
      a9: "179,600",
      a10: "12",
      a11: "0",
    },
    {
      key: "2",
      a1: "某产品二期",
      a2: "7845241800020228",
      a3: "-",
      a4: "-",
      a5: "王**",
      a6: "328,810",
      a7: "31,900",
      a8: "3,195",
      a9: "179,600",
      a10: "24",
      a11: "0",
    },
  ];

  const columns: ColumnProps<any>[] = [
    {
      title: "产品名称",
      dataIndex: "a1",
      key: "a1",
      align: "center",
    },
    {
      title: "订单号",
      dataIndex: "a2",
      key: "a2",
      align: "center",
    },
    {
      title: "资产类别",
      dataIndex: "a3",
      key: "a3",
      align: "center",
    },
    {
      title: "资产到期日",
      dataIndex: "a4",
      key: "a4",
      align: "center",
    },
    {
      title: "客户姓名",
      dataIndex: "a5",
      key: "a5",
      align: "center",
    },
    {
      title: "厂商指导价",
      dataIndex: "a6",
      key: "a6",
      align: "center",
    },
    {
      title: "首付",
      dataIndex: "a7",
      key: "a7",
      align: "center",
    },
    {
      title: "月租",
      dataIndex: "a8",
      key: "a8",
      align: "center",
    },
    {
      title: "尾款",
      dataIndex: "a9",
      key: "a9",
      align: "center",
    },
    {
      title: "已还期数",
      dataIndex: "a10",
      key: "a10",
      align: "center",
    },
    {
      title: "当前剩余期数",
      dataIndex: "a11",
      key: "a11",
      align: "center",
    },
  ];

  return (
    <div className="homes">
      {/* <Card>
        <header>
          <div className="img">
            <img src={logoImg} alt="" />
          </div>
          <div className="text">
            <div className="title">你好，管理员</div>
            <div className="desc">最近登录：2020-04-05 12：31：37</div>
          </div>
        </header>
      </Card> */}

      <Card
        title="融资租赁资产"
        style={{ marginTop: "20px" }}
        className="messages"
      >
        <Row gutter={24} className="rows">
          <Col span={24} className="cols">
            <Card>
              {/* <h2 style={{ textAlign: "center" }}>汽车类资产</h2> */}
              <Table
                dataSource={dataSource}
                columns={columns}
                pagination={false}
              />
            </Card>
          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default Home;
